import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FichaDaObraComponent } from './ficha-da-obra/ficha-da-obra.component';
import { ResultadoFiltrosComponent } from './filtros-buscas-modulos/resultado-filtros/resultado-filtros.component';
import { AlterarDadosCadastraisComponent } from './header/perfil-usuario/alterar-dados-cadastrais/alterar-dados-cadastrais.component';
import { AlterarSenhaComponent } from './header/perfil-usuario/alterar-senha/alterar-senha.component';
import { MeuPerfilComponent } from './header/perfil-usuario/meu-perfil/meu-perfil.component';
import { MinhasObrasComponent } from './home/listagem-obras/minhas-obras/minhas-obras.component';
import { ObrasEquipeComponent } from './home/listagem-obras/obras-equipe/obras-equipe.component';
import { ObrasNaoVistasComponent } from './home/listagem-obras/obras-nao-vistas/obras-nao-vistas.component';
import { MetricasComponent } from './metricas/metricas.component';
import { TarefasComponent } from './tarefas/tarefas.component';
import { TarefasEmpresaComponent } from './empresas/tarefas-empresa/tarefas-empresa.component';
import { HomeComponent } from './home/home.component';
import { authGuard } from './shared/services/auth/auth.guard';
import { empresasGuard } from './shared/services/auth/empresas.guard';
import { RedefinirSenhaComponent } from './login/redefinir-senha/redefinir-senha.component';


const routes: Routes = [

  { path: 'login', component: LoginComponent },
  { path: 'redefinir-senha/:token', component: RedefinirSenhaComponent },

  { path: '', component: HomeComponent, canActivate: [authGuard] },

  { path: 'usuario',                  component: MeuPerfilComponent,             canActivate: [authGuard] },
  { path: 'usuario/senha',            component: AlterarSenhaComponent,          canActivate: [authGuard] },
  { path: 'usuario/dados-cadastrais', component: AlterarDadosCadastraisComponent, canActivate: [authGuard] },

  { path: 'obras/minhas',     component: MinhasObrasComponent,  canActivate: [authGuard] },
  { path: 'obras/equipe',     component: ObrasEquipeComponent,  canActivate: [authGuard] },
  { path: 'obras/nao-vistas', component: ObrasNaoVistasComponent, canActivate: [authGuard] },
 

  { path: 'estatisticas', component: DashboardComponent, canActivate: [authGuard] },
  { path: 'relatorios',   component: MetricasComponent,  canActivate: [authGuard] },
  { path: 'tarefas',      component: TarefasComponent,   canActivate: [authGuard] },
  { path: 'empresas/tarefas', component: TarefasEmpresaComponent, canActivate: [authGuard, empresasGuard] },

  { path: 'buscas/imobiliario',    component: ResultadoFiltrosComponent, canActivate: [authGuard] },
  { path: 'buscas/industrial',     component: ResultadoFiltrosComponent, canActivate: [authGuard] },
  { path: 'buscas/edificacoes',    component: ResultadoFiltrosComponent, canActivate: [authGuard] },
  { path: 'buscas/infraestrutura', component: ResultadoFiltrosComponent, canActivate: [authGuard] },
  { path: 'buscas/:modulo/detalhes/:id', component: FichaDaObraComponent, canActivate: [authGuard] },

  {
    path: 'busca/empresa',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./buscas/buscas-empresa/buscas-empresa.component').then(
        (m) => m.BuscasEmpresaComponent
      ),
  },
  {
    path: 'busca/obra',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./buscas/buscas-id-obra/buscas-id-obra.component').then(
        (m) => m.BuscasIdObraComponent
      ),
  },
  {
    path: 'busca/salvas',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./buscas/buscas-salvas/buscas-salvas.component').then(
        (m) => m.BuscasSalvasComponent
      ),
  },
  {
    path: 'busca/salvas/editar/:id',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./buscas/buscas-salvas/buscas-salvas.component').then(
        (m) => m.BuscasSalvasComponent
      ),
  },

  { path: 'empresas', redirectTo: 'empresas/novo', pathMatch: 'full' },

  {
    path: 'empresas/salvas',
    canActivate: [authGuard, empresasGuard],
    loadComponent: () =>
      import('./empresas/empresas-salvas/empresas-salvas.component').then(
        (m) => m.EmpresasSalvasComponent
      ),
  },
  {
    path: 'empresas/novo',
    canActivate: [authGuard, empresasGuard],
    loadComponent: () =>
      import('./empresas/empresas.component').then(
        (m) => m.EmpresasComponent
      ),
  },
  {
    path: 'empresas/minha-carteira',
    canActivate: [authGuard, empresasGuard],
    loadComponent: () =>
      import('./empresas/minha-carteira/minha-carteira.component').then(
        (m) => m.MinhaCarteiraComponent
      ),
  },
  {
    path: 'empresas/detalhes/:module/:id',
    canActivate: [authGuard, empresasGuard],
    loadComponent: () =>
      import('./empresas/empresa-detalhes/empresa-detalhes.component').then(
        (m) => m.EmpresaDetalhesComponent
      ),
  },

  {
    path: '404',
    loadComponent: () =>
      import(
        './shared/components/pagina-nao-encontrada/pagina-nao-encontrada.component'
      ).then((m) => m.PaginaNaoEncontradaComponent),
  },

  { path: 'default.asp', redirectTo: '', pathMatch: 'full' },
  { path: 'Home/default.asp', redirectTo: '', pathMatch: 'full' },

  { path: '**', redirectTo: '404' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}